import gql from 'graphql-tag';

export default gql`
  fragment preleadCustomizeItemDateFragment on PreleadCustomizeItemDate {
    id
    value
    clientPreleadCustomizeItemId
  }
`;
